<template>
    <div class="loading-wrapper" v-show="isLoading">
        <img src="@/assets/images/loading.png" alt="pic" class="demo-spin-icon-load">
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false
        }
    }
}
</script>
<style scope lang="sass">
.loading-wrapper
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.1);
    .demo-spin-icon-load
        animation: ani-demo-spin 1s linear infinite;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 20%;

@keyframes ani-demo-spin
    from
        transform: rotate(0deg);
    50%
        transform: rotate(180deg);
    to
        transform: rotate(360deg);
</style>



// WEBPACK FOOTER //
// src/components/loading.vue